import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import memberWelcome from './zh-CN/memberWelcome';
import register from './zh-CN/register';
import staff from './zh-CN/staff';
import memberList from './zh-CN/memberList';
import dashboard from './zh-CN/dashboard';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.copyright.produced': '蓝海科技工作室出品',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...memberWelcome,
  ...register,
  ...staff,
  ...memberList,
  ...dashboard,
  'pages.403.subTitle': '抱歉，您没有访问此页面的权限。',
  'pages.403.back': '返回首页',
  'menu.account.logout': '退出登录',
  'menu.account.logout.confirm': '确认退出登录',
  'menu.account.logout.confirm.content': '您确定要退出登录吗？',
  'menu.account.logout.success': '已成功退出登录',
  'menu.account.logout.failed': '退出登录失败',
  
  'menu.account.changePassword': '修改密码',
  'menu.account.changePassword.currentPassword': '当前密码',
  'menu.account.changePassword.currentPassword.required': '请输入当前密码',
  'menu.account.changePassword.newPassword': '新密码',
  'menu.account.changePassword.newPassword.required': '请输入新密码',
  'menu.account.changePassword.password.tooShort': '密码长度不能少于6个字符',
  'menu.account.changePassword.confirmPassword': '确认新密码',
  'menu.account.changePassword.confirmPassword.required': '请确认新密码',
  'menu.account.changePassword.passwordMismatch': '两次输入的密码不一致',
  'menu.account.changePassword.success': '密码修改成功',
  'menu.account.changePassword.failed': '密码修改失败',
  'menu.account.changePassword.incorrectPassword': '当前密码不正确',
  'pages.memberList.pagination.total': '共 {total} 条记录',
  'pages.memberList.pagination.pageSize': '条/页',
  'pages.memberList.pagination.jump': '跳至',
  'pages.memberList.pagination.page': '页',
  
  // 礼品卡列表
  'pages.giftCardList.title': '礼品卡列表',
  'pages.giftCardList.create': '创建礼品卡',
  'pages.giftCardList.createVirtual': '创建虚拟礼品卡',
  'pages.giftCardList.createPhysical': '创建实体礼品卡',
  'pages.giftCardList.downloadPhysical': '批量下载实体卡号',
  'pages.giftCardList.code': '礼品卡编号',
  'pages.giftCardList.physicalCardNumber': '实体卡号',
  'pages.giftCardList.value': '礼品卡面值',
  'pages.giftCardList.initialAmount': '初始金额',
  'pages.giftCardList.balance': '剩余余额',
  'pages.giftCardList.balanceStatus': '余额',
  'pages.giftCardList.balanceStatus.all': '全部礼品卡',
  'pages.giftCardList.balanceStatus.withBalance': '有余额',
  'pages.giftCardList.balanceStatus.withoutBalance': '无余额',
  'pages.giftCardList.status': '状态',
  'pages.giftCardList.createTime': '创建时间',
  'pages.giftCardList.activeDate': '激活日期',
  'pages.giftCardList.activeBy': '激活人',
  'pages.giftCardList.activationStatus': '激活状态',
  'pages.giftCardList.activationStatus.all': '全部礼品卡',
  'pages.giftCardList.activationStatus.active': '已激活',
  'pages.giftCardList.activationStatus.inactive': '未激活',
  'pages.giftCardList.expiryDate': '到期日期',
  'pages.giftCardList.validDays': '有效期（天）',
  'pages.giftCardList.actions': '操作',
  'pages.giftCardList.actions.details': '详情',
  'pages.giftCardList.note': '备注',
  'pages.giftCardList.date': '日期范围',
  'pages.giftCardList.refresh': '刷新',
  'pages.giftCardList.email': '电子邮箱',
  'pages.giftCardList.phone': '手机号码',
  'pages.giftCardList.tempEmail': '临时电子邮箱',
  'pages.giftCardList.tempPhone': '临时手机号码',
  'pages.giftCardList.contactInfo': '联系方式类型',
  'pages.giftCardList.search.infoType.placeholder': '请选择联系方式类型',
  'pages.giftCardList.contactValue': '联系方式',
  'pages.giftCardList.search.infoValue.placeholder': '请输入联系方式',
  'pages.giftCardList.createDate': '创建日期',
  
  'pages.giftCardList.search.code.placeholder': '请输入礼品卡编号',
  'pages.giftCardList.search.cardNumber': 'Card ID / 实体卡号',
  'pages.giftCardList.search.status.placeholder': '请选择状态',
  'pages.giftCardList.search.date.start': '开始日期',
  'pages.giftCardList.search.date.end': '结束日期',
  'pages.giftCardList.search.submit': '搜索',
  'pages.giftCardList.search.reset': '重置',
  
  'pages.giftCardList.create.success': '礼品卡创建成功',
  'pages.giftCardList.create.error': '礼品卡创建失败',
  'pages.giftCardList.create.value.required': '请输入礼品卡面值',
  'pages.giftCardList.create.value.placeholder': '请输入礼品卡面值',
  'pages.giftCardList.create.balance.required': '请输入初始余额',
  'pages.giftCardList.create.balance.placeholder': '请输入初始余额',
  'pages.giftCardList.create.initialAmount.required': '请输入初始金额',
  'pages.giftCardList.create.initialAmount.placeholder': '请输入初始金额',
  'pages.giftCardList.create.email.placeholder': '请输入电子邮箱',
  'pages.giftCardList.create.phone.placeholder': '请输入手机号码',
  'pages.giftCardList.create.expiryDate.placeholder': '请选择到期日期',
  'pages.giftCardList.create.validDays.required': '请输入有效天数',
  'pages.giftCardList.create.validDays.placeholder': '请输入有效天数',
  'pages.giftCardList.create.note.placeholder': '请输入备注信息',
  'pages.giftCardList.physical.issuingStore': '发卡门店',
  'pages.giftCardList.physical.storeRequired': '请选择发卡门店',
  'pages.giftCardList.physical.quantity': '数量',
  'pages.giftCardList.physical.batch': '创建批次',
  'pages.giftCardList.physical.allBatches': '全部实体礼品卡',
  'pages.giftCardList.physical.loadError': '加载实体礼品卡选项失败',
  'pages.giftCardList.physical.createSuccess': '已创建 {count} 张实体礼品卡',
  'pages.giftCardList.physical.createError': '创建实体礼品卡失败',
  'pages.giftCardList.physical.batchLoadError': '加载实体礼品卡批次失败',
  'pages.giftCardList.physical.downloadError': '下载实体卡号失败',
  
  'pages.giftCardList.level': '礼品卡类型',
  'pages.giftCardList.create.level.required': '请选择礼品卡类型',
  'pages.giftCardList.create.level.placeholder': '请选择礼品卡类型',
  'pages.giftCardList.error.headOffice': '无法获取总部信息',
  'pages.giftCardList.error.fetchLevels': '获取礼品卡类型失败',
  'pages.giftCardList.error.storeId': '未找到门店ID',
  'pages.giftCardList.error.invalidStoreId': '门店ID格式不正确',
  'pages.giftCardList.error.fetchFailed': '获取礼品卡列表失败',
  'pages.giftCardList.error.fetchStoreFailed': '获取门店信息失败',
  'pages.giftCardList.error.noLevels': '未找到礼品卡等级配置，请先在管理后台创建礼品卡等级',
  
  'pages.giftCardList.status.active': '激活',
  'pages.giftCardList.status.inactive': '未激活',
  'pages.giftCardList.status.expired': '已过期',
  'pages.giftCardList.status.used': '已使用',
  'pages.giftCardList.status.cancelled': '已取消',
  
  'pages.giftCardList.pagination.total': '共 {total} 条记录',
  'pages.giftCardList.pagination.pageSize': '条/页',
  'pages.giftCardList.pagination.jump': '跳至',
  'pages.giftCardList.pagination.page': '页',
  
  'app.common.cancel': '取消',
  'app.common.create': '创建',
  'pages.store.giftCardDetails.send.email': '发送邮件',
  'pages.store.giftCardDetails.send.phone': '发送短信',
  'pages.store.giftCardDetails.send.card': '发送卡片',
  'pages.store.giftCardDetails.send.wallet': '发送到钱包',
  'pages.store.giftCardDetails.email.placeholder': '请输入电子邮箱',
  'pages.store.giftCardDetails.phone.placeholder': '请输入手机号码',

  // Additional translations for messages and missing labels.
  'app.common.request.error': '请求失败，请重试',
  'app.common.request.noResponse': '服务器未响应，请重试',
  'pages.store.giftCardDetails.email.invalid': '请输入有效的邮箱地址',
  'pages.store.giftCardDetails.expiry.placeholder': '请选择过期时间',
  'pages.store.giftCardDetails.send.sms.success': '礼品卡短信发送成功',
  'pages.store.giftCardDetails.send.email.success': '礼品卡邮件发送成功',
  'pages.store.giftCardDetails.send.error': '礼品卡发送失败，请重试',
  'pages.store.giftCardDetails.unavailable': '礼品卡数据不存在',
  'pages.store.giftCardDetails.phone.missing': '礼品卡没有关联手机号码',
  'pages.store.giftCardDetails.email.missing': '礼品卡没有关联邮箱',
  'pages.store.giftCardDetails.fetch.error': '获取礼品卡详情失败',
  'pages.store.giftCardDetails.edit.success': '修改礼品卡信息成功',
  'pages.store.giftCardDetails.edit.error': '修改礼品卡信息失败',
  'pages.store.memberDetails.send.sms.success': '会员卡短信发送成功',
  'pages.store.memberDetails.send.email.success': '会员卡邮件发送成功',
  'pages.store.memberDetails.send.error': '会员卡发送失败，请重试',
  'pages.store.memberDetails.fetch.error': '获取会员详情失败',
  'pages.store.memberDetails.headOffice.error': '无法获取总部信息',
  'pages.store.memberDetails.levels.error': '获取会员等级列表失败',
  'pages.store.memberDetails.unavailable': '会员信息不可用',
  'pages.store.memberDetails.points.modify.success': '修改积分成功',
  'pages.store.memberDetails.points.modify.error': '修改积分失败',
  'pages.store.voucherDetails.fetch.error': '获取优惠券详情失败',
  'pages.store.voucherDetails.unavailable': '优惠券信息不可用',
  'pages.store.voucherDetails.edit.success': '优惠券信息更新成功',
  'pages.store.voucherDetails.edit.error': '优惠券信息更新失败',
  'app.common.invalidParams': '参数错误',
  'app.common.user.fetch.error': '获取用户信息失败',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'account.center.articles': '文章',
  'account.center.applications': '应用',
  'account.center.projects': '项目',
  'account.center.tags': '标签',
  'account.center.team': '团队',
  'pages.admin.subPage.title': '只有管理员可以查看此页面',
  'pages.welcome.alertMessage': '更快更强的组件已发布。',
  'dashboard.analysis.introduce': '指标说明',
  'dashboard.analysis.action1': '操作一',
  'dashboard.analysis.action2': '操作二',
  'dashboard.analysis.sales': '销售额',
  'pages.voucherList.modal.fetchMemberLevelsFailed': '获取会员等级失败',
  'pages.headOffice.settings.title': '总部设置',
  'pages.orderDetails.status.paid': '已支付',
  'pages.orderDetails.status.refund': '已退款',
  'pages.orderDetails.status.partiallyRefunded': '部分退款',
  'pages.orderDetails.remarks': '备注',
  'pages.orderDetails.noRemarks': '无',
  'pages.orderDetails.PointsBalanceAfterTransaction': '交易后积分余额',
  'pages.orderDetails.cardUsedAmount': '卡片使用金额',
  'pages.orderDetails.BalanceAfterTransaction': '交易后余额',
  'pages.orderDetails.spentValue': '消费金额',
  'component.message.success': '操作成功',
  'component.message.failed': '操作失败',
  'component.message.required': '此项为必填项',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.exception': '请输入异常原因',
  'pages.searchTable.title': '查询表格',
  'pages.login.email.placeholder': '邮箱',
  'memberPortal.profile.resetPassword.success': '密码重置成功',
  'memberPortal.profile.resetPassword.error': '密码重置失败',
  'memberPortal.profile.save.success': '个人信息更新成功',
  'memberPortal.profile.save.error': '个人信息更新失败',
  'memberPortal.profile.email.invalid': '请输入有效的邮箱地址',
  'memberPortal.profile.mobile.invalid': '手机号须以04开头且为10位数字',
  'memberPortal.profile.verification.sent': '验证码发送成功',
  'memberPortal.profile.verification.sendError': '验证码发送失败',
  'memberPortal.profile.phone.updateSuccess': '手机号更新成功',
  'memberPortal.profile.phone.updateError': '手机号更新失败',
  'memberPortal.loading.full': '正在加载门店资源…',
  'memberPortal.profile': '个人信息',
  'memberPortal.profile.points': '当前积分',
  'memberPortal.transactions': '交易记录',
  'memberPortal.profile.memberId': '会员 ID',
  'memberPortal.profile.name': '姓名',
  'memberPortal.profile.firstName': '名',
  'memberPortal.profile.middleName': '中间名',
  'memberPortal.profile.lastName': '姓',
  'memberPortal.profile.mobile': '手机号',
  'memberPortal.profile.mobile.required': '请输入手机号',
  'memberPortal.profile.mobilePlaceholder': '请输入手机号',
  'memberPortal.profile.email': '邮箱',
  'memberPortal.profile.emailPlaceholder': '请输入邮箱',
  'memberPortal.profile.ageGroup': '年龄段',
  'memberPortal.profile.ageGroupPlaceholder': '请选择年龄段',
  'memberPortal.profile.registerTime': '注册时间',
  'memberPortal.profile.cancel': '取消',
  'memberPortal.profile.save': '保存',
  'memberPortal.profile.edit': '编辑',
  'memberPortal.profile.logout': '退出登录',
  'memberPortal.profile.resetPassword': '重置密码',
  'memberPortal.history.filter': '按日期筛选',
  'memberPortal.history.selectDate': '请选择日期',
  'memberPortal.history.clearFilter': '清除',
  'memberPortal.history.empty': '暂无交易记录',
  'memberPortal.history.store': '门店',
  'memberPortal.history.invoice': '发票',
  'memberPortal.history.status': '状态',
  'memberPortal.history.reward': '奖励积分',
  'memberPortal.history.redeem': '兑换积分',
  'memberPortal.history.after': '余额',
  'memberPortal.history': '历史记录',
  'memberPortal.profile.logout.confirm': '确认退出登录',
  'memberPortal.profile.logout.message': '退出登录后将跳转到注册页面。',
  'memberPortal.profile.logout.cancel': '取消',
  'memberPortal.profile.resetPassword.title': '重置密码',
  'memberPortal.profile.resetPassword.newPassword': '新密码',
  'memberPortal.profile.resetPassword.newPasswordRequired': '请输入新密码',
  'memberPortal.profile.resetPassword.passwordMinLength': '密码长度须为6至16位',
  'memberPortal.profile.resetPassword.newPasswordPlaceholder': '请输入新密码',
  'memberPortal.profile.resetPassword.confirmPassword': '确认密码',
  'memberPortal.profile.resetPassword.confirmPasswordRequired': '请确认密码',
  'memberPortal.profile.resetPassword.passwordMismatch': '两次输入的密码不一致',
  'memberPortal.profile.resetPassword.confirmPasswordPlaceholder': '请确认新密码',
  'memberPortal.profile.resetPassword.cancel': '取消',
  'memberPortal.profile.resetPassword.submit': '重置',
  'memberPortal.profile.phone.verificationTitle': '验证新手机号',
  'memberPortal.profile.phone.newMobile': '新手机号',
  'memberPortal.profile.phone.verificationCode': '验证码',
  'memberPortal.profile.phone.codeRequired': '请输入验证码',
  'memberPortal.profile.phone.codeLength': '验证码须为6位数字',
  'memberPortal.profile.phone.codePlaceholder': '请输入6位验证码',
  'memberPortal.profile.phone.sendCode': '发送验证码',
  'memberPortal.profile.phone.resendText': '重新发送验证码倒计时',
  'memberPortal.profile.phone.resend': '重新发送',
  'memberPortal.profile.phone.cancel': '取消',
  'memberPortal.profile.phone.verify': '验证',
  'memberPortal.memberCard': '会员卡',
  'pages.searchTable.new': '新建',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.login.email.required': '请输入邮箱',
  'cards.classification.label': '卡片分类',
  'cards.classification.all': '全部分类',
  'cards.classification.virtual': '虚拟卡',
  'cards.classification.physical': '实体卡',
  'cards.classification.physical_virtualized': '实体卡（虚拟化）',
  'cards.classification.physical_virtualized.gift': 'e-giftcard',
  'cards.classification.physical_virtualized.voucher': 'e-voucher',
};
